<script setup>
// core
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n'

// icons
import ErrorCircle from '@/components/Notifications/icons/error-circle.vue';
import CloseIcon from '@/components/Icons/CloseIcon.vue';


const store = useStore();
const { locale } = useI18n();

const lasError = computed(() => {
    return store?.getters['notifications/getLastErrorNotification']
})

const hasLastError = computed(() => lasError.value && !!Object.values(lasError.value)?.length)

const hideBanner = () => {
    store.commit('notifications/SET_LAST_NOTIFICATION', 'close');
}

</script>

<template>
    <div v-if="hasLastError" class="notification-banner">
        <div class="notification-banner__content">
            <ErrorCircle />
            <span>{{ lasError.title[locale] }}</span>
        </div>
        <div class="notification-banner__hide" @click="hideBanner">
            <CloseIcon />
        </div>
    </div>
</template>

<style scoped lang="scss">
.notification-banner {
    position: absolute;
    z-index: 999999;
    top: 0;
    right: 0;
    left: 0;
    padding: 3px 8px;
    border-top: 1px solid #F9D2D8;
    border-bottom: 1px solid #F9D2D8;
    background: #FCF2F3;
    display: flex;
    align-items: center;
    gap: 10px;

    &__content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        color: #DD2039;
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;

        svg {
            min-width: 16px;
            height: 16px;
        }
    }

    &__hide {
        cursor: pointer;
        color: #E57A44;
    }
}
</style>